// Admin configuration - centralized location for admin access control
// 
// Note: These emails are also used in the database migration file:
// supabase/migrations/20240101000002_admin_content_policies.sql
// 
// If you add/remove admin emails here, you'll need to update the database function too.
export const ADMIN_EMAILS = process.env.REACT_APP_ADMIN_EMAILS 
  ? process.env.REACT_APP_ADMIN_EMAILS.split(',').map(email => email.trim())
  : [
      'john@openorg.fyi',
      'adam@openorg.fyi',
      'johnfwillcocks@gmail.com'
      // Add your email here
    ];

// Helper function to check if a user is an admin
export const isUserAdmin = (user) => {
  return user && ADMIN_EMAILS.includes(user.email);
}; 